import { MessageCircle, Mail, LifeBuoy, Package } from "lucide-react";
import { Link } from "react-router-dom";
import { useSettings } from "@/context/SettingsContext";
import { buildWhatsAppUrl } from "@/lib/format";
import { Seo } from "@/components/Seo";

// Assistência técnica: canal PRÓPRIO (separado do WhatsApp comercial de vendas).
export default function AssistenciaPage() {
  const settings = useSettings();
  const ast = settings.assistencia || {};
  const wa = (ast.whatsapp || "5521997459912").replace(/\D/g, "");
  const email = ast.email || "hgmoveis2022@gmail.com";
  const subject = ast.email_subject || "Assistência Técnica - HG Móveis";
  const mailto = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent("Olá! Preciso de assistência técnica.\n\nPedido (se houver): \nProduto: \nDescreva o que aconteceu: \n")}`;

  return (
    <div className="container-store py-12 sm:py-16 max-w-2xl" data-testid="assistencia-page">
      <Seo
        title="Assistência Técnica | HG Móveis"
        description="Assistência técnica da HG Móveis: suporte para produtos entregues, garantia e reparos, pelo WhatsApp ou e-mail."
        canonical="/assistencia"
      />
      <div className="text-center">
        <span className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-brand-light text-brand">
          <LifeBuoy className="w-8 h-8" />
        </span>
        <h1 className="mt-4 font-heading text-3xl sm:text-4xl font-bold text-gray-900 tracking-tight">Assistência Técnica</h1>
        <p className="mt-2 text-gray-600 text-sm sm:text-base">
          Precisa de ajuda com um produto entregue? Fale com o nosso canal exclusivo de assistência —
          com número do pedido em mãos, o atendimento é ainda mais rápido.
        </p>
      </div>

      <div className="mt-8 grid sm:grid-cols-2 gap-4">
        <a
          href={buildWhatsAppUrl("Olá! Preciso de assistência técnica da HG Móveis.", wa)}
          target="_blank"
          rel="noreferrer"
          className="flex flex-col items-center gap-2 bg-green-600 hover:bg-green-700 text-white rounded-2xl p-6 transition-colors"
          data-testid="assistencia-whatsapp"
        >
          <MessageCircle className="w-8 h-8" />
          <span className="font-heading font-bold text-lg">WhatsApp da Assistência</span>
          <span className="text-sm text-green-100">(21) 99745-9912</span>
        </a>
        <a
          href={mailto}
          className="flex flex-col items-center gap-2 bg-brand hover:bg-brand/90 text-white rounded-2xl p-6 transition-colors"
          data-testid="assistencia-email"
        >
          <Mail className="w-8 h-8" />
          <span className="font-heading font-bold text-lg">Enviar e-mail para assistência</span>
          <span className="text-sm text-blue-100">{email}</span>
        </a>
      </div>

      <div className="mt-6 bg-blue-50 border border-blue-100 rounded-2xl p-5 text-sm text-gray-700 leading-relaxed">
        <p className="font-semibold text-gray-900 mb-1">Antes de chamar, tenha em mãos:</p>
        <p>• Número do pedido (está no e-mail de confirmação e em "Meus Pedidos")</p>
        <p>• Fotos do produto e do defeito, se houver</p>
        <p className="mt-2 text-xs text-gray-500">
          Todos os produtos têm garantia de 3 meses. Consulte as regras em{" "}
          <Link to="/pagina/garantia" className="text-brand font-medium hover:underline">Garantia</Link> e acompanhe seus pedidos em{" "}
          <Link to="/pedidos" className="text-brand font-medium hover:underline inline-flex items-center gap-1"><Package className="w-3.5 h-3.5" />Meus Pedidos</Link>.
        </p>
      </div>
    </div>
  );
}
